export default __webpack_public_path__ + "static/media/final-step1.0f8a72a8.jpeg";